import { render, staticRenderFns } from "./ConfigurationGroup.vue?vue&type=template&id=1722d32e&"
import script from "./ConfigurationGroup.vue?vue&type=script&lang=js&"
export * from "./ConfigurationGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports